import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { RelanceJournalResponseDto } from '@/api/relance-journal-client';
import { useRelanceJournalClient } from '@/api/relance-journal-client-context';

// =============================================================================
// use-relance-journal.ts — Hook TanStack Query du JOURNAL DES RELANCES admin (R15-COM-05).
// =============================================================================
// Une seule lecture (useQuery) — l'admin CONSULTE le journal des relances émises (DBU §2.7.1). Le client
// effectif vient du RelanceJournalClientProvider (doublable, stub-first). ZÉRO règle métier ici : l'autorité
// (RBAC AdminSessionGuard, agrégation multi-fournisseurs, K-anonymity/redaction) est l'API. Clé de cache
// portée par le campaignId (ressource d'URL, autorité API).

/** Consulte le journal des relances d'une campagne (read-only admin). */
export function useRelanceJournal(
  campaignId: string,
): UseQueryResult<RelanceJournalResponseDto, Error> {
  const client = useRelanceJournalClient();
  return useQuery<RelanceJournalResponseDto, Error>({
    queryKey: ['relance-journal', campaignId],
    queryFn: () => client.fetchJournal(campaignId),
  });
}
